// @mui
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFns';
import esES from 'date-fns/locale/es'
import { LocalizationProvider } from '@mui/x-date-pickers-pro';

// i18n
import './locales/i18n';

// slick-carousel
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// scroll bar
import 'simplebar/src/simplebar.css';

// map
import 'mapbox-gl/dist/mapbox-gl.css';

// lazy image
import 'react-lazy-load-image-component/src/effects/blur.css';
import 'react-lazy-load-image-component/src/effects/opacity.css';
import 'react-lazy-load-image-component/src/effects/black-and-white.css';

import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

// contexts
import { AccessProvider } from './contexts/AccessContext';
import { DataContextProvider } from './data/DataContext';
import { SettingsProvider } from './contexts/SettingsContext';
import { CollapseDrawerProvider } from './contexts/CollapseDrawerContext';

// redux
import { ReduxProvider } from './redux/store';

import { AuthProvider } from './contexts/JWTContext';

//
import App from './App';

// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <AuthProvider>
        <AccessProvider>
            <DataContextProvider>
                <HelmetProvider>
                    <ReduxProvider>
                        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={esES} >
                            <SettingsProvider>
                                <CollapseDrawerProvider>
                                    <BrowserRouter>
                                        <App />
                                    </BrowserRouter>
                                </CollapseDrawerProvider>
                            </SettingsProvider>
                        </LocalizationProvider>
                    </ReduxProvider>
                </HelmetProvider>
            </DataContextProvider>
        </AccessProvider>
    </AuthProvider>
);
